import type { SEOMeta } from "@/utils/seo";

export const SEO_BRAND = "AvachatAI";

/** Natural keyword set for homepage & global fallback — use in titles/descriptions, not spam. */
export const SEO_PRIMARY_KEYWORDS =
  "AvachatAI, Ava AI companion, AI emotional support, mental wellness app, AI chat for anxiety, loneliness support app, judgment-free AI chat, AI mental health companion, emotional intelligence AI, Neuroava";

export const DEFAULT_OG_IMAGE_PATH = "/site-media/brand-icon-512.png";

export const HOME_PAGE_SEO: SEOMeta = {
  title: "AvachatAI (Ava) | AI Emotional Support Companion & Mental Wellness App",
  description:
    "AvachatAI (Ava) is an emotionally intelligent AI companion for judgment-free chat, anxiety support, and daily mental wellness. Free to start on iOS & Android — built by Neuroava.",
  canonicalPath: "/",
  keywords: SEO_PRIMARY_KEYWORDS,
};

export const BLOG_INDEX_SEO: SEOMeta = {
  title: `Mental Wellness & AI Blog | ${SEO_BRAND}`,
  description:
    "Expert articles on emotional wellness, AI companionship, anxiety, relationships, and self-care — from the AvachatAI team.",
  canonicalPath: "/blog",
  keywords: `${SEO_BRAND}, mental health blog, emotional wellness articles, AI companion, anxiety tips, self-care blog`,
};

export const CONTACT_PAGE_SEO: SEOMeta = {
  title: `Contact ${SEO_BRAND} | Support & Partnerships`,
  description:
    "Contact AvachatAI for product support, press, or partnerships. We respond to messages about Ava, privacy, and mental wellness features.",
  canonicalPath: "/contact",
  keywords: `${SEO_BRAND} contact, Ava support, Neuroava contact, AI companion support`,
};

export const TERMS_PAGE_SEO: SEOMeta = {
  title: `Terms of Service | ${SEO_BRAND}`,
  description: "Terms of Service for AvachatAI (Ava) — acceptable use, subscriptions, and your rights when using our apps and website.",
  canonicalPath: "/terms-of-service",
  robots: "index, follow",
};

export const PRIVACY_PAGE_SEO: SEOMeta = {
  title: `Privacy Policy | ${SEO_BRAND}`,
  description:
    "How AvachatAI collects, uses, and protects your data. Privacy-first design for conversations with Ava on iOS, Android, and the web.",
  canonicalPath: "/privacy-policy",
  robots: "index, follow",
};
